import { defaultInventoryColumnVisibilityModel } from "../../consts/inventory";
import {
  TOGGLE_THEME,
  TOGGLE_SIDEBAR,
  GET_PREFERENCES,
  TOGGLE_SETTINGS,
  CHANGE_TABLE_PAGE_SIZE,
  TOGGLE_INVENTORY_MODE,
  UPDATE_INVENTORY_COLUMN_VISIBILITY_MODEL,
} from "../actions/userPreferencesActions";

const initialState = {
  themeDark: true,
  sidebarClosed: false,
  settingsOpen: false,
  tablePageSize: 50,
  inventory_mode: "assets",
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case GET_PREFERENCES:
      return {
        ...state,
        themeDark: payload?.themeDark,
        sidebarClosed: payload?.sidebarClosed,
        tablePageSize: payload?.tablePageSize,
        inventory_mode: payload?.inventory_mode ?? 'assets',
        inventory_columnVisibilityModel: payload?.inventory_columnVisibilityModel ?? defaultInventoryColumnVisibilityModel
      };

    case TOGGLE_THEME:
      return { ...state, themeDark: !state.themeDark };

    case TOGGLE_SIDEBAR:
      return { ...state, sidebarClosed: !state.sidebarClosed };

    case TOGGLE_SETTINGS:
      return { ...state, settingsOpen: payload.bool };

    case CHANGE_TABLE_PAGE_SIZE:
      return { ...state, tablePageSize: payload };

    case TOGGLE_INVENTORY_MODE:
      return { ...state, inventory_mode: payload };
    case UPDATE_INVENTORY_COLUMN_VISIBILITY_MODEL:
      return { ...state, inventory_columnVisibilityModel: payload };

    default:
      return state;
  }
}
